import AutoHeightIframe from '@Components/General/auto-height-iframe';
import { Card, CardContent } from '@mui/material';
import { compile } from 'handlebars';

const EmailContent = ({
    htmlContent,
    overlayComponent,
    placeholder,
    error,
}) => {
    const html = compile(
        htmlContent || '',
        {},
    )({
        preview_text: '',
        email_footer: '',
    });

    return (
        <Card sx={{ border: error ? 2 : 0, borderColor: 'error.main' }}>
            <CardContent sx={{ borderRadius: 4, position: 'relative' }}>
                {htmlContent ? (
                    <>
                        {overlayComponent}
                        <AutoHeightIframe htmlContent={html} />
                    </>
                ) : (
                    placeholder
                )}
            </CardContent>
        </Card>
    );
};

export default EmailContent;
